<template>
  <div class="footer" :class="{ fixed: initSkeleton }">
    <div class="footer-main">
      <div class="footer-left">
        Coypright 2025 ©
        <br>
        BestDealer.All Rights Reserved
      </div>
      <div class="footer-right">
        CS Center | Support@bestdealer.com Monday - Friday | AM 10:00 - PM 18:00
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const initSkeleton = computed(() => {
  return store.state.initSkeleton
})

</script>

<style scoped lang="less">
.footer {
  position: relative;
  width: 100%;
  background: url("@/assets/footer-bg.png") center;
  z-index: 99;
  margin-top: auto;
  &.fixed {
    position: fixed;
    bottom: 0;
  }
  .footer-main {
    display: flex;
    justify-content: space-between;
    height: 64px;
    width: 1200px;
    margin: auto;
    align-items: end;
    .footer-left {
      font-size: 11px;
      font-family: mon-500;
      color: #DBEFF9;
      line-height: 16px;
      margin-bottom: 14px;
    }

    .footer-right {
      font-size: 11px;
      font-family: mon-500;
      color: #DBEFF9;
      line-height: 16px;
      margin-bottom: 14px;
    }
  }
}
</style>
